import { section2Data } from "../../../../data/neurofeed";
import classes from "./Section2.module.css";
import section2Image from "./neurofeedback_section2.webp";

export default function Section2() {
  return (
    <section className={classes.section}>
      <div className={classes.shell}>
        <div className={classes.layout}>
          <div className={classes.content}>
            <header className={classes.header}>
              <h2 className={classes.heading}>
                Why Choose <span>Us?</span>
              </h2>

              <p className={classes.description}>
                We have designed this program to integrate smoothly into your
                space. It&apos;s versatile, economical, and simple, increasing
                the quality of care you provide.
              </p>
            </header>

            <div className={classes.benefits}>
              {section2Data.map(({ icon: Icon, title, description }) => (
                <article className={classes.benefit} key={title}>
                  <span className={classes.icon} aria-hidden="true">
                    <Icon />
                  </span>

                  <div>
                    <h3 className={classes.benefitTitle}>{title}</h3>
                    <p className={classes.benefitDescription}>{description}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>

          <div className={classes.imageWrap}>
            <img
              src={section2Image}
              alt="Neurofeedback therapy session"
              className={classes.image}
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
